import user from './user';
import extensions from './extensions';
import linkage from './linkage';
import studies from './studies';
import viewports from './viewports';

const reducers = {
  user,
  extensions,
  linkage,
  studies,
  viewports,
};

export default reducers;
